import React, { useEffect, useState, useRef, useContext } from "react";
import { getShops, getUsers, getWarehouses, ListOrder, ListOrderMaster, ListSalesReport, ListUserReport } from "../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { NaviGate, numberToWords } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";

const Empreport = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
  const [data, setData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedReturnInvoice, setSelectedReturnInvoice] = useState(null);
  const [Details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const modalContentRef = useRef(null);

  // Filter states
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [warehouseId, setWarehouseId] = useState("");
  const [empId, setEmpId] = useState("");
  const [users, setUsers] = useState([]);
  const [shops, setShops] = useState([]);
  const [warehouse, setWarehouse] = useState([]);

  useEffect(() => {
    fetchData();
    fetchUsers();
    fetchShops();
    fetchWarehouses();
  }, []);

  const fetchUsers = async (page = "", text = "") => {
    try {
      const response = await getUsers(page, text, shopItem.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchShops = async (page = 1, text = "") => {
    try {
      const response = await getShops(page, text);
      if (response.data && response.data.data) {
        setShops(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchWarehouses = async () => {
    try {
      const response = await getWarehouses();
      if (response && response.data) {
        setWarehouse(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching warehouses:', error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or undefined date

    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Ensure valid date

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const fetchData = async () => {
    try {
      const formattedFromDate = formatDate(fromDate);
      const formattedToDate = formatDate(toDate);

      var filter = `start_date=${formattedFromDate}&end_date=${formattedToDate}&user_id=${empId}&shop_id=${companyId}`;

      const response = await ListUserReport(filter);
      if (response.data && response.data.data) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleGet = async (state) => {
    try {
      setDetails(state);
      const response = await ListOrder(state.unique_id);
      if (response.data && response.data.data) {
        setSelectedInvoice(response.data.data);
      }
      if (response.data && response.data.return_sale) {
        setSelectedReturnInvoice(response.data.return_sale);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
    setShowModal(true);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
      <NaviGate />
        <h6 className="mt-3 text-uppercase">Employee Report</h6>

        {/* Filters Section */}
        <form onSubmit={handleFilter} className="card p-4 shadow-sm">
          <div className="row g-3">
            {/* From Date */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="fromDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <label htmlFor="fromDate">From Date</label>
              </div>
            </div>

            {/* To Date */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                <label htmlFor="toDate">To Date</label>
              </div>
            </div>

            {/* Company ID Dropdown */}
            <div className="col-md-2">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="companyId"
                  value={companyId}
                  onChange={(e) => setCompanyId(e.target.value)}
                >
                  <option value="">Select Company</option>
                  {shops?.map((shop) => (
                    <option key={shop.shop_id} value={shop.shop_id}>
                      {shop.shop_title}
                    </option>
                  ))}
                </select>
                <label htmlFor="companyId">Company ID</label>
              </div>
            </div>

            {/* Warehouse ID Dropdown */}
            <div className="col-md-2">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="warehouseId"
                  value={warehouseId}
                  onChange={(e) => setWarehouseId(e.target.value)}
                >
                  <option value="">Select Warehouse</option>
                  {warehouse
                    .map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.title}
                      </option>
                    ))}
                </select>
                <label htmlFor="warehouseId">Warehouse ID</label>
              </div>
            </div>

            {/* Employee ID Dropdown */}
            <div className="col-md-2">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="empId"
                  value={empId}
                  onChange={(e) => setEmpId(e.target.value)}
                >
                  <option value="">Select Employee</option>
                  {users
                    .filter((emp) => emp.role_title === "Super Admin" || emp.role_title === "admin")
                    .map((emp) => (
                      <option key={emp.user_Id} value={emp.user_Id}>
                        {emp.full_name} ({emp.role_title})
                      </option>
                    ))}
                </select>
                <label htmlFor="empId">Employee ID</label>
              </div>
            </div>

            {/* Filter Button */}
            <div className="col-md-2 d-flex align-items-end">
              <button
                type="submit"
                className="btn btn-primary w-100"
                style={{
                  background: 'linear-gradient(45deg, #007bff, #6610f2)',
                  border: 'none',
                }}
              >
                <i className="fas fa-filter"></i> Filter
              </button>
            </div>
          </div>
        </form>

        {/* Sales Table */}
        <div className="table-responsive text-center my-1 w-100 position-relative">
          <table className="table table-striped table-sm table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.full_name}</td>
                  <td>{item.role_title}</td>
                  <td>{item.phone}</td>
                  <td>{item.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          tabIndex={-1}
          role="dialog"
          style={{ display: showModal ? "block" : "none" }}
          aria-hidden={!showModal}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content" ref={modalContentRef}>
              <div className="modal-header border-0 pb-0">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="row mx-3 mt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="col-md-1">
                    <img
                      src="assets/images/tech_logo.webp"
                      alt="Left Logo"
                      style={{ maxHeight: "38px" }}
                    />
                  </div>
                  <div>
                    <img
                      src="assets/images/arabic.jpg"
                      alt="Left Logo"
                      style={{ maxHeight: "38px" }}
                    />
                  </div>
                </div>
                <div className="col-12 text-center">
                  <p className="fw-bold font-14 mb-0">
                    P.O. Box 605/512, AL Khoudh Souq, Muscat, Sultanate of Oman
                  </p>
                  <p className="fw-medium font-13 mb-0">
                    Mobile: +968 91120555 | E-Mail: Sales@toptecno.com |
                    www.toptecno.com
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col text-center">
                  <h3
                    className="fw-bold mt-2"
                    style={{ textDecoration: "underline" }}
                  >
                    فاتورة
                  </h3>
                  <h3 className="fw-bold">INVOICE</h3>
                </div>
              </div>
              <div className="row border-top border-bottom pt-3 mx-3 pb-2">
                <div className="col-6">
                  <div
                    className="p-2"
                    style={{
                      border: ".8px solid #dee2e6",
                      minHeight: 150,
                    }}
                  >
                    <h6 className="fw-bold">Customer Details:</h6>
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium font-13 mb-1">Name:</p>
                      <p
                        className="fw-bold font-13 mb-1"
                        style={{ textDecoration: "underline" }}
                      >
                        {Details?.customer_name}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium font-13 mb-1">Email:</p>
                      <p
                        className="fw-bold font-13 mb-1"
                        style={{ textDecoration: "underline" }}
                      >
                        {Details?.customer_email}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium font-13 mb-1">Address:</p>
                      <p
                        className="fw-bold font-13 mb-1"
                        style={{ textDecoration: "underline" }}
                      >
                        {Details?.additional_details}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="fw-medium font-13 mb-1">Phone:</p>
                      <p
                        className="fw-bold font-13 mb-1"
                        style={{ textDecoration: "underline" }}
                      >
                        {Details?.customer_phone}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <table className="table table-bordered text-center align-middle m-0">
                    <tbody>
                      <tr>
                        <td className="text-start fw-bold">
                          Invoice No: {Details.unique_id}
                        </td>
                        <td className="text-start fw-bold">
                          Date: {Details.date}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table table-bordered text-center align-middle">
                    <tbody>
                      <tr>
                        <td className="text-start d-flex flex-row">
                          <p
                            className="fw-bold text-start mb-0"
                            style={{ width: "40%" }}
                          >
                            L.P.O No:{" "}
                          </p>
                          <p
                            className="text-start mb-0"
                            style={{ width: "60%" }}
                          >
                            {" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start d-flex flex-row">
                          <p
                            className="fw-bold text-start mb-0"
                            style={{ width: "40%" }}
                          >
                            Sales Person:{" "}
                          </p>
                          <p
                            className="text-start mb-0"
                            style={{ width: "60%" }}
                          >
                            {" "}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start d-flex flex-row">
                          <p
                            className="fw-bold text-start mb-0"
                            style={{ width: "40%" }}
                          >
                            Payment Terms:{" "}
                          </p>
                          <p
                            className="text-start mb-0"
                            style={{ width: "60%" }}
                          >
                            {" "}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-4 mx-4">
                <div
                  className="col-md-12"
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    background: `linear-gradient(to bottom, rgba(255, 255, 255, 70%), rgba(255, 255, 255, 70%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
                    backgroundSize: "60%",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="table-responsive">
                    <table className=" border table-sm table-bordered w-100">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "10%" }}>
                            <span>الرقم</span>
                            <br />
                            Sl. No.
                          </th>
                          <th style={{ width: "40%" }}>
                            <span>التفاصيل</span>
                            <br />
                            Particulars
                          </th>
                          <th style={{ width: "15%" }}>
                            <span>الكمية</span>
                            <br />
                            Qty
                          </th>
                          <th style={{ width: "15%" }}>
                            <span>سعر الوحدة</span>
                            <br />
                            Unit Price
                          </th>
                          <th style={{ width: "20%" }}>
                            <span>المبلغ الإجمالي</span>
                            <br />
                            Total Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(selectedInvoice) &&
                          selectedInvoice.map((item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.product_name}</td>
                              <td>{item.qty}</td>
                              <td>{item.sales_price}</td>
                              <td>{item.sales_price * item.qty}</td>
                            </tr>
                          ))}
                        {selectedReturnInvoice?.length > 0 && (
                          <tr>
                            <td colSpan="5" className="text-center">
                              <strong>Return Products</strong>
                            </td>
                          </tr>
                        )}
                        {Array.isArray(selectedReturnInvoice) &&
                          selectedReturnInvoice.map((item, index) => (
                            <tr key={`additional-product-${index}`}>
                              <td>{index + 1}</td>
                              <td>{item.product_name}</td>
                              <td>{item.qty}</td>
                              <td>{item.sales_price}</td>
                              <td className="text-danger">
                                {"- " + item.amount_per_price || "N/A"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <br />
                        </tr>
                        <tr>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent fw-bold text-end">
                            Total
                          </td>
                          <td className="bg-transparent">
                            {selectedInvoice
                              ?.reduce(
                                (acc, item) =>
                                  acc + (item.sales_price * item.qty || 0),
                                0
                              )
                              .toFixed(0)}
                          </td>
                        </tr>
                        <tr>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent fw-bold text-end">
                            Discount
                          </td>
                          <td className="bg-transparent">
                            {selectedInvoice
                              ?.reduce((acc, item) => {
                                const discount =
                                  item.discount_type == 1
                                    ? parseFloat(item.sales_price || 0) *
                                    parseFloat(item.qty || 0) *
                                    (parseFloat(item.discount || 0) / 100)
                                    : parseFloat(item.discount || 0);

                                return acc + discount;
                              }, 0)
                              .toFixed(3)}
                          </td>
                        </tr>

                        <tr>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent fw-bold text-end">
                            Tax
                          </td>
                          <td className="bg-transparent">
                            {"+ " + Details?.vat}
                          </td>
                        </tr>
                        <tr>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent"></td>
                          <td className="bg-transparent fw-bold text-end">
                            Grand Total
                          </td>
                          <td>
                            {/* {Array.isArray(selectedInvoice) && selectedInvoice.reduce(
                                (acc, item) =>
                                  acc + (item.total || 0),
                                0
                              ).toFixed(3)} */}
                            {Details.total}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={6} className="text-start">
                            <p className="my-2">
                              <strong>
                                Amount in Words:&nbsp;
                                {/* {numberToWords(Math.floor(selectedInvoice?.reduce((acc, item) => acc + (item.purchase_price * item.qty || 0), 0).toFixed(3)))} */}
                                {numberToWords(Math.floor(Details.total))}
                                &nbsp;Riyal Only.
                              </strong>
                            </p>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div
                className="row mt-3 mx-4 px-2 mb-3"
                style={{ fontSize: "16px" }}
              >
                <div className="col-md-4 border">
                  <p className="fw-bold mt-2">Terms &amp; Conditions:</p>
                  <div className="" style={{ height: 120 }}></div>
                </div>
                <div className="col-md-4 border">
                  <p className="fw-bold mt-2">Bank Account:</p>
                  <div className="" style={{ height: 120 }}></div>
                </div>
                <div className="col-md-4 border">
                  <p className="fw-bold mt-2">For Top Tecno:</p>
                  <div className="" style={{ height: 120 }}></div>
                </div>
              </div>

              {/* Modal Footer with buttons */}
              <div className="modal-footer mx-1 mt-4">
                <button type="button" className="btn btn-info">
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Empreport;
